var scope_0 = require('/home/runner/work/kastle/kastle/packages/karstdev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0f6337cd74656376722de7dda1f5e08b.js').default;

var scope_1 = require('/home/runner/work/kastle/kastle/packages/karstdev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/77dc5871c5b6487d2a3f76ea282981ab.js').default;

var scope_2 = require('/home/runner/work/kastle/kastle/packages/karstdev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9d07700772695760292880383c6a81c8.js').default;

var scope_3 = require('/home/runner/work/kastle/kastle/packages/karstdev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b91a06ba54bfe339b56fa48c175547b1.js').default;

var scope_4 = require('/home/runner/work/kastle/kastle/packages/karstdev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/caa6387412356de633f5afed9cd9b688.js').default;

var scope_5 = require('/home/runner/work/kastle/kastle/packages/karstdev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

var scope_6 = require('/home/runner/work/kastle/kastle/packages/karstdev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fd2f9813f4b760f25119d48e6c9f8832.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6);